import React, { Component} from "react";
import { navigate } from "gatsby";

import provisionalModuleDataBasedOnLanguage from "./gausta/provisionalModuleData";
import LoginModal from "../components/loginModal";
import { getQuery } from "../utils/query";

export default class LoginModalWatcher extends Component {
  state = {
    displayLoginModal: false,
    redirected: false
  }

  componentDidUpdate() {
    if (getQuery().redirected && !this.state.redirected) { this.setState({ displayLoginModal: true, redirected: true }); }
  }

  componentDidMount() {
    if (getQuery().redirected && !this.state.redirected) { this.setState({ displayLoginModal: true, redirected: true }); }
  }

  render(){
    const { displayLoginModal } = this.state;
    const { language } = this.props;
    if (displayLoginModal) {
      return (
        <LoginModal
          show={displayLoginModal}
          closeFn={() => this.setState({ displayLoginModal: false })}
          onFinishLogin={() => navigate("/account")}
          moduleData={provisionalModuleDataBasedOnLanguage(language)}
        />
      )
    }

    return null;
  }
}